import type { FC, PropsWithChildren } from 'react';
import { useEffect } from 'react';

import posthog from 'posthog-js';
import { PostHogProvider as PostHogProviderBase } from 'posthog-js/react';

import { useGetBillingProfile } from 'entities/billing/api/useGetBillingProfile';
import { useGetWidgetSettings } from 'hooks/customization';
import { useAuth } from 'shared/lib/auth/useAuth';

posthog.init(import.meta.env.VITE_APP_POSTHOG_API_KEY, {
  api_host: import.meta.env.VITE_APP_POSTHOG_HOST,
  ui_host: 'https://us.posthog.com',
  defaults: '2025-05-24',
});

export const PostHogProvider: FC<PropsWithChildren> = ({ children }) => {
  const { user } = useAuth();
  const { data: widgetSettings } = useGetWidgetSettings();
  const { data: billingProfile } = useGetBillingProfile();

  useEffect(() => {
    if (user) {
      const { id, email, profile, company } = user;

      posthog?.identify(id, {
        email,
        name: `${profile?.first_name} ${profile?.last_name?.charAt(0)}`,
        productName: 'dashboard',
        role: profile?.role.id,
        companyType: company?.company_type,
        useCase: widgetSettings?.use_case,
        subscriptionId: billingProfile?.subscription_id,
      });
    }
  }, [user, widgetSettings, billingProfile]);

  return <PostHogProviderBase client={posthog}>{children}</PostHogProviderBase>;
};
